import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { fetchReviews } from "../../../actions/sticker_maker/stickersActions";
import { useAppDispatch } from "../../../store/hooks";
import { queryParams } from "../../../helpers/UrlHelpers";

import PageLayout from "../_partials/PageLayout";
import PageHeader from "./_partials/_PageHeader";
import List from "../Stickers/_partials/_List";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";
import NewCategory from "../Categories/New";
import EditCategory from "../Categories/Edit";
import CategoriesSettings from "../Categories/Settings";
import ListViewButtons from "../../../componets/ListViewButtons";

const LIMIT = 42;
const DEFAULT_VIEW = 'list';

const PacksReviews = () => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const listType: any   = queryParams.get(searchParams,'view') || DEFAULT_VIEW;

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['order_by', 'order', 'date_from', 'date_to']
    );

    dispatch(fetchReviews(params));
  }, [searchParams, currentPage, dispatch]);

  return (
    <PageLayout>
      <PageHeader title={'Reviews'} />

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            dateRange
            orderBy={{
              defaultKey: 'id',
              defaultSort: 'desc',
              items: [
                { name: 'Date', key: 'id' }
              ]
            }}
          >
            <ListViewButtons align='right' defaultType={DEFAULT_VIEW} />
          </Filter>
        </Wrapper>

        <List limit={LIMIT} type={listType} />

        <NewCategory />
        <EditCategory />
        <CategoriesSettings />
      </div>
    </PageLayout>
  );
}

export default PacksReviews;
